// Returns the pixel height needed to show only the first `count` children of a
// scroll container, so the remaining items can be reached by scrolling.
// Returns null when the container is missing or does not have extra items.
export function getFirstItemsHeight(container, count = 3) {
  if (!container || container.children.length <= count) {
    return null;
  }

  const lastVisible = container.children[count - 1];
  const containerRect = container.getBoundingClientRect();
  const lastVisibleRect = lastVisible.getBoundingClientRect();
  const paddingBottom = parseFloat(
    window.getComputedStyle(container).paddingBottom,
  );

  const height =
    lastVisibleRect.bottom -
    containerRect.top +
    container.scrollTop +
    (paddingBottom || 0);

  return Math.ceil(height);
}
